// extracted by mini-css-extract-plugin
module.exports = {"IconItem":"IconItem_IconItem__N4BGI","IconItemIcon":"IconItem_IconItemIcon__W9PvP"};